import React from "react";
import {Image, Menu} from "antd";
import logo from "../../assets/images/logo.png"
import styles from "./index.module.scss"
import "./index.scss";

const Navbar = ({items = [], selectedKeys = [], onClick = f => f}) => {

    const handleClick = (e) => onClick(e.key);

    return (
        <div className={styles.navbar}>
            <div className="container">
                <div className={styles.container}>
                    <a href="/pages/index" style={{flexGrow: 0, marginRight: 'auto'}}>
                        <Image src={logo} alt="Logo" preview={false} className={styles.logo}/>
                    </a>

                    <Menu onClick={handleClick} selectedKeys={selectedKeys} mode="horizontal" items={items}
                          className={styles.menu}/>
                </div>
            </div>
        </div>
    )
}

export default Navbar;